export var SourceType;
(function (SourceType) {
    SourceType["API"] = "API";
    SourceType["PLP"] = "PLP";
    SourceType["MANIFEST"] = "MANIFEST";
    SourceType["WILSON"] = "WILSON";
    SourceType["SWAP_PAGE"] = "SWAP_PAGE";
    SourceType["TRIPS_PAGE"] = "TRIPS_PAGE";
    SourceType["ONFLEET"] = "ONFLEET";
    SourceType["AUTO"] = "AUTO";
    SourceType["MY_ACCOUNT"] = "MY_ACCOUNT";
    SourceType["FIRST_PICKUP_PAGE"] = "FIRST_PICKUP_PAGE";
})(SourceType || (SourceType = {}));
//# sourceMappingURL=sourceType.js.map